import { render, staticRenderFns } from "./SharingMetric.vue?vue&type=template&id=52c288e2&scoped=true&"
import script from "./SharingMetric.vue?vue&type=script&lang=ts&"
export * from "./SharingMetric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c288e2",
  null
  
)

export default component.exports